/** Basic company info (name, currency) — available to all authenticated users. */
export const getCompanyBasicInfoQuery = `
  query GetCompanyBasicInfo {
    getCompanyBasicInfo {
      code
      company {
        name
        currencyCode
        businessType
      }
    }
  }
`;

const companyAddressFields = `
          country
          province
          district
          sector
          cell
          village
          streetAddress
          region
          city
          subCounty
          parish
          road
          poBox
          postalCode
          county
          constituency
          ward
          town
          estateStreet
          streetVillageHamlet
          houseNumber
`;

export const getCompanyDetailsQuery = `
  query GetCompanyDetails {
    getCompanyDetails {
      code
      company {
        name
        businessType
        currencyCode
        registrationNumber
        description
        vatPercentage
        vatCalculationMode
        address {
${companyAddressFields}
        }
      }
    }
  }
`;

export const updateCompanyQuery = `
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      code
      company {
        name
        businessType
        currencyCode
        registrationNumber
        description
        vatPercentage
        vatCalculationMode
        address {
${companyAddressFields}
        }
      }
    }
  }
`;
